__turbopack_context__.v({
  "card": "PainPoints-module__A2P-da__card",
  "cardIndex": "PainPoints-module__A2P-da__cardIndex",
  "cardText": "PainPoints-module__A2P-da__cardText",
  "cardTitle": "PainPoints-module__A2P-da__cardTitle",
  "description": "PainPoints-module__A2P-da__description",
  "grid": "PainPoints-module__A2P-da__grid",
  "group": "PainPoints-module__A2P-da__group",
  "kicker": "PainPoints-module__A2P-da__kicker",
  "outcomePanel": "PainPoints-module__A2P-da__outcomePanel",
  "panelKicker": "PainPoints-module__A2P-da__panelKicker",
  "panelLink": "PainPoints-module__A2P-da__panelLink",
  "panelTitle": "PainPoints-module__A2P-da__panelTitle",
  "section": "PainPoints-module__A2P-da__section",
  "statement": "PainPoints-module__A2P-da__statement",
  "ticker": "PainPoints-module__A2P-da__ticker",
  "title": "PainPoints-module__A2P-da__title",
  "track": "PainPoints-module__A2P-da__track",
});
